/**
 * @file jobSearchRoot.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 01, 2026 09:06
 */
import { all, fork } from 'redux-saga/effects';

import jobSearchInitialQuery from 'src/store/sagas/jobSearch/jobSearchInitialQuery.saga';
import jobSearchDelete from 'src/store/sagas/jobSearch/jobSearchDelete.saga';

export default function* rootSaga() {
    yield all([
        fork(jobSearchInitialQuery),
        fork(jobSearchDelete),
    ]);
}